import { jsx as _jsx } from "react/jsx-runtime";
import { withRouter } from 'react-router';
import { format } from 'date-fns';
import { BaseLineChart, generateTicks } from '../BaseLineChart';
import { IS_APP_CODEAC } from '../../../../constants/env';
import { withPlanInfo } from '../../../../components/hoc/WithPlanInfo';
import { TrialGraph } from '../../../../components/charts/TrialGraph';
import { withHandleActivateTrial } from '../../../../components/hoc/WithHandleActivateTrial';
const CodeCoverageChartBase = ({ activeBranch, baseLink, codeCoverage, history, isRepositoryPrivate, proPlan, handleActivateTrial }) => {
    const showTrialGraph = IS_APP_CODEAC && !proPlan && isRepositoryPrivate;
    const { commitList } = activeBranch; // ToDo: We don't need to pass branch. We just need the list of commits.
    const coveredCommits = codeCoverage.commits; // ToDo: We don't need to pass codeCoverage. We just need the list of commits.
    const handleClick = (chartElement) => {
        if (chartElement.activeLabel) {
            history.push(`${baseLink}/commits/${commitList.commits[commitList.commits.length - chartElement.activeTooltipIndex - 1]?.hash}`);
        }
    };
    const data = commitList.commits.map((commit) => ({
        dateTime: format(new Date(Number(commit.datetime)), 'MM/dd HH:mm'),
        message: commit.message,
        hash: commit.hash,
        id: commit.id,
        chartLines: {
            changedLines: coveredCommits[commit.id]?.changedLines || void 0,
            changedLinesThreshold: commit.options?.thresholds?.coveredChangedLinesPercentage,
            branches: coveredCommits[commit.id]?.digest.branches || void 0,
            branchesThreshold: commit.options?.thresholds?.coveredBranches,
            functions: coveredCommits[commit.id]?.digest.functions || void 0,
            functionsThreshold: commit.options?.thresholds?.coveredFunctions,
            lines: coveredCommits[commit.id]?.digest.lines || void 0,
            linesThreshold: commit.options?.thresholds?.coveredLines,
        },
    })).reverse();
    const chartDataWithoutNullable = data.filter(({ chartLines }) => chartLines.lines || chartLines.functions || chartLines.branches);
    if (showTrialGraph) {
        return _jsx(TrialGraph, { trialGraphType: "code-coverage-dashboard", handleActivateTrial: handleActivateTrial });
    }
    return _jsx(BaseLineChart, { height: 260, chartData: chartDataWithoutNullable, yTicks: generateTicks(0, 100, 10), chartType: 'codeCoverage', tooltipData: coveredCommits, handleClick: handleClick });
};
// @ts-expect-error TS2345: Argument of type is not assignable to parameter of type
export const Chart = withRouter(withHandleActivateTrial(withPlanInfo(CodeCoverageChartBase)));
